// extracted by mini-css-extract-plugin
module.exports = {"addUser":"styles_addUser__YDw2Z","btnForm":"styles_btnForm__59oZG","checkboxGroup":"styles_checkboxGroup__3eOWq"};